import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardMetrics = ({ metrics, loading }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-EG')?.format(amount);
  };

  const metricCards = [
    {
      id: 'properties',
      title: 'عقاراتي',
      value: metrics?.totalProperties || 0,
      icon: 'Building2',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10',
      borderColor: 'border-blue-500/20'
    },
    {
      id: 'contracts',
      title: 'العقود النشطة',
      value: metrics?.activeContracts || 0,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    },
    {
      id: 'pending',
      title: 'معاملات معلقة',
      value: metrics?.pendingTransactions || 0,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    {
      id: 'signatures',
      title: 'توقيعات مطلوبة',
      value: metrics?.pendingSignatures || 0,
      icon: 'FileSignature',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20'
    }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4]?.map(i => (
          <div key={i} className="bg-card rounded-lg border border-border p-4">
            <div className="animate-pulse">
              <div className="h-4 bg-muted rounded w-1/2 mb-3"></div>
              <div className="h-8 bg-muted rounded w-1/3"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" dir="rtl">
      {metricCards?.map(metric => (
        <div 
          key={metric?.id}
          className={`bg-card rounded-lg border ${metric?.borderColor} p-4 hover:shadow-warm transition-all duration-250`}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-2">{metric?.title}</p>
              <p className={`text-3xl font-bold ${metric?.color}`}>
                {metric?.value}
              </p>
            </div>
            <div className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon 
                name={metric?.icon} 
                size={24} 
                color={`var(--color-${metric?.color?.replace('text-', '')})`} 
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardMetrics;